import type { VariantVideosDefinition } from 'types/videos'

import type { M01_VIDEOS } from './default'

export const M01_DARK_VIDEOS = {
  fitnessLevelSquats: {
    gymVisualsSquat: {
      src: '/videos/m01/dark/fitness-level/squat-gym-visual.webm',
    },
  },
  fitnessLevelPushups: {
    gymVisualsPushup: {
      src: '/videos/m01/dark/fitness-level/pushup-gym-visual.webm',
    },
  },
  fitnessLevelPlank: {
    gymVisualsPlank: {
      src: '/videos/m01/dark/fitness-level/plank-gym-visual.webm',
    },
  },
} satisfies VariantVideosDefinition<typeof M01_VIDEOS>
